import { FC, ReactNode } from 'react';

import { Title as MantineTitle, TitleProps } from '@mantine/core';

import cx from './Page.module.scss';

const Title: FC<TitleProps & { children?: ReactNode }> = ({ children, ...props }) => (
    <MantineTitle {...props} className={cx.title}>
        {children}
    </MantineTitle>
);

export { Title };
